import { Text } from "@certn/cascadia";
import { DataDisplay } from "@certn/cascadia-react";
import { useTranslation } from "react-i18next";

import { formatMonitoringChangeValue } from "../monitoringRunChangeText";
import type { EnrollmentDetailCheck } from "../types";
import { monitoringDetailsTableWrapperStyle } from "./monitoringDetailsTableStyles";

type ChangeRow = EnrollmentDetailCheck["last_run_changes"][number] & {
  id: string;
};

const COLUMN_WIDTH = "33%";

export function MonitoringChangeDetailsTable({
  changes,
}: {
  changes: EnrollmentDetailCheck["last_run_changes"];
}) {
  const { t } = useTranslation();

  const rows: ChangeRow[] = changes.map((change, index) => ({
    ...change,
    id: `${change.label}-${index}`,
  }));

  return (
    <div className={monitoringDetailsTableWrapperStyle}>
      <DataDisplay<ChangeRow>
        testId="monitoring-change-details-table"
        renderTopMargin={false}
        hideHeaderBorder
        aria-label={t("Change details")}
        columns={[
          {
            key: "label",
            name: t("Change attribute"),
            width: COLUMN_WIDTH,
            isRowHeader: true,
            render: (row) => (
              <Text style="form/body-secondary">{row.label}</Text>
            ),
          },
          {
            key: "old_value",
            name: t("Previous value"),
            width: COLUMN_WIDTH,
            render: (row) => (
              <Text style="form/body-secondary">
                {formatMonitoringChangeValue(row.old_value, t)}
              </Text>
            ),
          },
          {
            key: "new_value",
            name: t("New value"),
            width: COLUMN_WIDTH,
            render: (row) => (
              <Text style="form/body-secondary">
                {formatMonitoringChangeValue(row.new_value, t)}
              </Text>
            ),
          },
        ]}
        rows={rows}
      />
    </div>
  );
}
